import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export const useStripFaireDirectWidgetAnalyticsQueryParams = (options?: {
  enabled?: boolean;
}) => {
  const { replace, location } = useHistory();
  const enabled = options?.enabled ?? true;

  useEffect(() => {
    if (!enabled) {
      return;
    }

    const searchParams = new URLSearchParams(location.search);

    if (!searchParams.has("wsi")) {
      return;
    }

    searchParams.delete("wsi");

    replace({
      ...location,
      search: searchParams.toString(),
    });
  }, [enabled, replace, location]);
};
